@if (label()) {
    <div class="pretty-easy-link-group__header">
        <div class="pretty-easy-link-group__label"
             [id]="label()">
            {{ label() | translate }}
        </div>
    </div>
}

<ul class="pretty-easy-link-group__list"
    [attr.aria-labelledby]="label()">
    @for (data of links(); track data.label) {
        <li class="pretty-easy-link-group__list-item">
            @if (data.type === 'link') {
                <app-pretty-easy-link [linkData]="data"
                                      [isSidebarFolded]="isSidebarFolded">
                </app-pretty-easy-link>
            } @else if (data.type === 'linkGroup') {
                <app-pretty-easy-link-group [slot]="data"
                                            [isSidebarFolded]="isSidebarFolded">
                </app-pretty-easy-link-group>
            } @else if (data.type === 'accordionLinkGroup') {
                <app-pretty-easy-accordion-link-group [slot]="data"
                                                      [isSidebarFolded]="isSidebarFolded"
                                                      [unfoldSidebar]="unfoldSidebar.bind(this)">
                </app-pretty-easy-accordion-link-group>
            } @else if (data.type === 'actionLink') {
                <app-pretty-easy-link [linkData]="data"
                                      [isSidebarFolded]="isSidebarFolded">
                </app-pretty-easy-link>
            } @else if (data.type === 'imageLink') {
                <app-pretty-easy-image-link [linkData]="data"
                                            [isSidebarFolded]="isSidebarFolded">
                </app-pretty-easy-image-link>
            }
        </li>
    }
</ul>